/* eslint-disable typescript-sort-keys/interface */
import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/styles' {
  interface ZIndex {
    base: number; // 일반 stacking context 기준점
    raised: number; // 컴포넌트 내부에서 한 단계 위로 올릴 요소
    sticky: number; // sticky tab / header, local toolbar
    localOverlay: number; // 컴포넌트 내부 overlay / skeleton
    localLoader: number; // 컴포넌트 내부 loading overlay 배경
    localLoaderContent: number; // 컴포넌트 내부 loading spinner / text
    dragIndicator: number; // drag and drop indicator
    stickyActionBar: number; // create form footer 등 하단 고정 action
    contentPopup: number; // sticky action bar 위, GNB 아래 떠야하는 본문 popup / dropdown
    navigationOverlay: number; // GNB, MegaMenu, navigation overlay
    navigationTop: number; // route progress bar처럼 navigation 위에 떠야 하는 상태 표시
    navigationDragLayer: number; // GNB navigation popup 위에 떠야 하는 drag preview
    modalPopup: number; // modal 내부 popup/dropdown/date picker
    modalLoader: number; // modal 전체를 막는 특수 loader
    globalLoader: number; // 전역 차단 loader 배경
    globalLoaderContent: number; // 전역 차단 loader spinner/text
    notification: number; // notification stack
    notificationTooltip: number; // notification tooltip
  }
}

export const createZIndex = (): ThemeOptions['zIndex'] => ({
  base: 0,
  raised: 1,
  sticky: 10,
  localOverlay: 15,
  localLoader: 20,
  localLoaderContent: 21,
  dragIndicator: 30,
  mobileStepper: 1000,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  stickyActionBar: 1290,
  contentPopup: 1295,
  navigationOverlay: 1300,
  navigationTop: 1310,
  navigationDragLayer: 1320,
  modal: 1400,
  modalPopup: 1410,
  modalLoader: 1420,
  snackbar: 1500,
  tooltip: 1600,
  globalLoader: 1700,
  globalLoaderContent: 1710,
  notification: 1800,
  notificationTooltip: 1810,
});
